.body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
}

.group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  align-items: center;
  display: flex;
  gap: 8px;
}

.item-muted {
  align-items: center;
  display: flex;
  gap: 8px;
}

.icon-created {
  color: var(--color-success, #16a34a);
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}

.icon-existed {
  color: var(--color-muted-foreground);
  flex-shrink: 0;
  height: 16px;
  width: 16px;
}

.note {
  background: var(--color-surface);
  border-radius: 8px;
  padding: 12px;
}

.pending {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 0;
}

.spinner {
  animation: spin 1s linear infinite;
  color: var(--color-muted-foreground);
  height: 32px;
  width: 32px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
